export function Skeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="animate-pulse space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-12 rounded-xl bg-gray-100" />
      ))}
    </div>
  );
}

export function EmptyState({ title, body, action }: { title: string; body: string; action?: React.ReactNode }) {
  return (
    <div className="rounded-2xl border border-dashed border-gray-200 bg-white px-6 py-14 text-center">
      <i className="ri-inbox-2-line text-3xl text-gray-300" />
      <h3 className="mt-3 text-sm font-bold text-gray-800">{title}</h3>
      <p className="mt-1 text-sm text-gray-500 max-w-md mx-auto">{body}</p>
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="rounded-2xl border border-rose-100 bg-rose-50 px-6 py-10 text-center">
      <p className="text-sm font-semibold text-rose-700">{message || 'حدث خطأ ما'}</p>
      <button type="button" onClick={onRetry} className="mt-3 px-3 py-1.5 text-xs font-bold rounded-lg bg-rose-600 text-white">
        إعادة المحاولة
      </button>
    </div>
  );
}

export function NoPermissionState() {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white px-6 py-14 text-center">
      <i className="ri-lock-2-line text-3xl text-gray-300" />
      <h3 className="mt-3 text-sm font-bold text-gray-800">لا توجد صلاحية</h3>
      <p className="mt-1 text-sm text-gray-500">اطلب من مدير النظام تفعيل صلاحية الوصول إلى الذكاء التجاري لدورك.</p>
    </div>
  );
}
